import React from 'react';
import { Navigate } from 'react-router-dom';

// Goal: create a private route that checks if the user is logged in
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    // Redirect to login if there's no token
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;